<template>
<div>
<div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
  <div v-if="changed">
  <div class="container">
       <h2 class="m-auto text-info text-center pt-5 pb-4">Contact Details </h2>
       <div class="col-sm-12 col-lg-8 m-auto bg-white py-4">
  <el-form :model="condata"  ref="condata" label-width="200px" :label-position="label" size="medium" status-icon @submit.native.prevent >
       <el-form-item
    label="Open time">
       <el-time-select
    placeholder="Start time"
    v-model="condata.startTime"
    :picker-options="{
      start: '00:00',
      step: '00:15',
      end: '10:00'
    }">
  </el-time-select>
   </el-form-item>
  
   <el-form-item
    label="Close time">
  <el-time-select
    placeholder="End time"
    v-model="condata.endTime"
    :picker-options="{
      start: '16:00',
      step: '00:15',
      end: '23:59',
      minTime: condata.startTime
    }">
  </el-time-select>
   </el-form-item>
   <el-form-item label="Shop Name" prop="name" :rules="[ { required: true, message: 'Please input shop name', trigger: 'blur' },
            { min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur' }]">
    <el-input v-model="condata.name" clearable placeholder="Shop Name"></el-input>
  </el-form-item>
  <el-form-item
    label="Contact Number 01"
    prop="phone1"
    :rules="[
      { type: 'number', message: 'telephone no must be a number'}]">
    <el-input  placeholder="777666666" v-model.number="condata.phone1" auto-complete="off" style="width:220px;" ></el-input>
  </el-form-item>
  <el-form-item
    label="Contact Number 02"
    prop="phone2">
    <el-input  placeholder="112222222" v-model.number="condata.phone2" auto-complete="off" style="width:220px;" ></el-input>
  </el-form-item>
  <el-form-item label="Email" prop="email"
  :rules="[
     
      { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }]">
    <el-input v-model="condata.email" placeholder="Email"></el-input>
  </el-form-item>
  <el-form-item label="Address" prop="address">
    <el-input type="textarea" v-model="condata.address" placeholder="Address"></el-input>
  </el-form-item>
  <el-form-item label="Delivery Details & Special Notes" prop="darea">
    <el-input type="textarea" v-model="condata.darea" placeholder="Delivery Details & Special Notes"></el-input>
  </el-form-item>
   <el-form-item label="Latitude" prop="lat">
    <el-input placeholder="Latitude" v-model.number="condata.lat" ></el-input>
  </el-form-item>
  <el-form-item label="Longtitude" prop="long">
    <el-input placeholder="Longtitude" v-model.number="condata.long" ></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="success" @click="getLatLon()">Get Latitude & Longtitude</el-button> 
  </el-form-item>
   <el-form-item>
    <el-button type="primary" @click="upDet('condata')">Update Details</el-button>
   
  </el-form-item>
  </el-form>
  </div>
  </div>
  </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from 'firebase/app';;
import { GeoCollectionReference, GeoFirestore, GeoQuery, GeoQuerySnapshot } from 'geofirestore';
import "firebase/firestore";
export default {
   data() {
      return {
        condata: {
            startTime: '',
            endTime: '',
            phone1:'',
            phone2:'',
            address:'',
            email:'',
            lat:'',
            long:'',
            name:'',
            darea:'',
            
        },
        shops: [],
        label:'',
        loading1:false,
        loading:false,
        changed:true,
      }
    },

    methods: {
       backToTop: function() {
        $('html,body').stop().animate({
          scrollTop: 0
        }, 'fast', 'swing');
      },
      getLatLon(){
         //getting current postiton using HTML5 Geolocation API
        if(navigator.geolocation) {
          navigator.geolocation.getCurrentPosition( (position) => {
                this.condata.lat = position.coords.latitude
                this.condata.long = position.coords.longitude
                }, (error) => {
                    if(error.code == 0){
                      alert('Unknown error occurred.');
                    }else if(error.code == 1){
                      alert('Permission denied. You cannot get latitude & longitude until you allow to access your loocation.')
                    }else if(error.code == 2){
                      alert('Position unavailable. Error response from location provider.')
                    }else if(error.code == 3){
                      alert('Location data request timed out.')
                    }
                },{timeout:10 * 1000})
          // console.log('this.formdata.lat', this.formdata.lat)
          // console.log('this.formdata.lat', position.coords.latitude)
        } else {
          alert("Geolocation is not supported by this browser.")
        }
      },
      upDet (cdata){
         this.$refs[cdata].validate(valid => {
        if (valid) {
            this.loading = true
            this.changed = false
             this.backToTop()
            // const firestore = firebase.firestore();
            // Create a GeoFirestore reference
            //const geofirestore = new GeoFirestore(firestore);
            // Create a GeoCollection reference
            //const geoshop = geofirestore.collection('shops').doc(this.shops[0].id);
            //console.log('uid',firebase.auth().currentUser.uid)
            // geoshop
            // .update({
            //   details: {
            //     stime: this.condata.startTime,
            //     etime: this.condata.endTime,
            //     tel1: this.condata.phone1,
            //     tel2: this.condata.phone2,
            //     address: this.condata.address,
            //     email: this.condata.email,
            //     name:this.shops[0].name,
            //     perm:'allowed'
            //     //  lat: this.condata.lat,
            //     //  lng: this.condata.long
            //   },
            //   cat:this.shops[0].cat,
            //   coordinates: new firebase.firestore.GeoPoint(this.condata.lat, this.condata.long)
            // })
            //  .then(doc => {
               db.collection('shops').doc(this.shops[0].id).update({
              details: {
                stime: this.condata.startTime,
                etime: this.condata.endTime,
                tel1: this.condata.phone1,
                tel2: this.condata.phone2,
                address: this.condata.address,
                email: this.condata.email,
                darea: this.condata.darea,
                 lat: this.condata.lat,
                 lng: this.condata.long
              },
              name: this.condata.name
              //coordinates: new firebase.firestore.GeoPoint(this.condata.lat, this.condata.long)
            }).then( ()=> {
              this.loading = false
              this.changed = true
            }).catch(error => alert(error));             
              //console.log('doc is', doc)
            //})
           // .catch(error => alert(error));
        } else {
          alert("error update!!!")
          return false;
        }
      })
      }
    },
    created(){
      //console.log('screen',screen.width)
      if(screen.width > 575){
        this.label = 'right'
      }else{
        this.label = 'top'
      }
      this.backToTop()
      this.loading1 = true
      this.changed =false
       db.collection("shops").where('owner', '==', firebase.auth().currentUser.uid ).get().then(querySnapshot => {
        this.shops = []
      querySnapshot.forEach(doc => {
					const data = {
            'id': doc.id,
            'details':doc.data().details,
            //'coordinates':doc.data().coordinates,
            'name': doc.data().name,
            'shoptype': doc.data().shoptype,
            'location': doc.data().location,
            'owner' : doc.data().owner,
            'visits': doc.data().visits,
            'homeimg':doc.data().homeimg,
            'plan':doc.data().plan,
            'cat' : doc.data().cat
            
          }
          this.shops.push(data)
            this.condata.startTime = this.shops[0].details.stime
            this.condata.endTime = this.shops[0].details.etime
            this.condata.phone1 = this.shops[0].details.tel1
            this.condata.phone2 = this.shops[0].details.tel2
            this.condata.address = this.shops[0].details.address
            this.condata.email = this.shops[0].details.email
            this.condata.name = this.shops[0].name
            this.condata.darea = this.shops[0].details.darea
             this.condata.lat = this.shops[0].details.lat
            this.condata.long = this.shops[0].details.lng
            //console.log('shop coordinates',this.shops[0].coordinates)
             this.loading1 = false
            this.changed = true
          //console.log('doc is',doc)
        })
          //console.log('querySnapshot is',querySnapshot)
          //console.log('querySnapshot data',querySnapshot.docs[0].data().details)
        }).catch(error => alert(error));
        
            // if (navigator.geolocation) {
            //     navigator.geolocation.getCurrentPosition( (position) => {
            //          this.condata.lat = position.coords.latitude
            //          this.condata.long = position.coords.longitude
            //     }, (error) => {
            //         if(error.code == 0){
            //           alert('Unknown error occurred.');
            //           this.fetched = true
            //         }else if(error.code == 1){
            //           alert('Permission denied. You cannot find near by ' + this.value + ' until you allow to access your loocation.')
            //           this.fetched = true
            //         }else if(error.code == 2){
            //           alert('Position unavailable. Error response from location provider.')
            //           this.fetched = true
            //         }else if(error.code == 3){
            //           alert('Location data request timed out.')
            //           this.fetched = true
            //         }})
            //     //  //console.log('this.condata.lat', this.condata.lat)
            //     //   //console.log('this.condata.lat', position.coords.latitude)
            // } else {
            //    alert("Geolocation is not supported by this browser.")
            // }

        // function showPosition(position) {
        //    this.condata.lat = position.coords.latitude
        //    this.condata.long = position.coords.longitude
        // }
				
    }
}
</script>

<style scoped>
@import url('~@/assets/admin/css/admin-loader.css');
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminContact.vue